module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_activity_automation-194c20ae7ffa787c09c26f21d18f5fc9.png";